import { Component, OnInit } from '@angular/core';

import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  selector: 'app-company-default',
  templateUrl: './company-default.component.html',
  styleUrls: ['./company-default.component.css']
})
export class CompanyDefaultComponent implements OnInit {

  headerColor = 'primary';
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches));

  constructor(public authService : AuthService,     
    private breakpointObserver: BreakpointObserver
    ) { }

  ngOnInit() {
  }

}
